<template>
	<div class="center_right">
		<div class="center_commNav">
			<div class="center_commNavItem" @click="activeName=item.id" :class="{'active':activeName==item.id}" v-for="(item,index) in commNavs">{{item.name}}</div>
		</div>
		<div v-show="activeName=='1'">
			<div class="center_filter">
				<div class="center_filterInput">
					<el-form :inline="true" label-width="100px">
						<el-form-item label="课程名称：">
							<el-input v-model="finiOnname" placeholder="请输入课程名称" clearable></el-input>
						</el-form-item>
						<el-form-item label="课程类型：">
							<el-select :popper-append-to-body='false' v-model="finiOntypeId" placeholder="请选择课程类型" clearable>
								<el-option :label="item.name" :value="item.id" v-for='(item,index) in typeList'></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="授课老师：">
							<el-input v-model="finiOnuserName" placeholder="请输入发布人" clearable></el-input>
						</el-form-item>
						<br />
						<el-form-item label="笔记名称：">
							<el-input v-model="finiOnnoteName" placeholder="请输入笔记名称" clearable></el-input>
						</el-form-item>
						<el-form-item>
							<div class="center_filterBtns">
								<el-button @click="searchfiniOnData" type='primary'>搜索</el-button>
								<el-button @click='clearfiniOnFilter'>重置</el-button>
							</div>
						</el-form-item>
					</el-form>
				</div>
			</div>
			<div class="center_tables center_coursenote clearfix">
				<div class="center_notetree">
					<el-tree :data="finiOnlistTree" node-key="id" :props="defaultProps" @node-click="handleNodeClick">
						<div class="custom-tree-node" slot-scope="{ node, data }">
							<div class="center_treeInfo" :class="'center_treeInfo'+node.level">
								{{data.name}} <span class="primaryColor">({{data.count || 0}})</span>
							</div>
						</div>
					</el-tree>
				</div>
				<div class="center_notelist clearfix">
					<emptymain :emptytext="'暂无笔记'" :emptylist='finiOnlistData'></emptymain>
					<div class="course_noteItem" v-for="item in finiOnlistData">
						<img src="@/images/course_noteBack.png" class="course_noteBack" />
						<div class="course_noteItemCont">
							<div class="course_noteItemType">
								<img src="@/images/note_left.png" />
								<span>课堂笔记</span>
							</div>
							<div class="course_noteItemEdit">
								<i class="el-icon-edit" @click="openEdit(item)"></i>
								<i class="el-icon-delete" @click="deleteNote(item)"></i>
							</div>
							<div class="course_noteItemTitle text-ellipsis">{{item.title}}</div>
							<div class="course_noteItemText">{{item.description}}</div>
							<div class="course_noteItemTime">{{item.updateTime |formatTime}}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<el-dialog title="我的笔记" class="open_dialogInfo" :visible.sync="note" :append-to-body='true' width="1000px" :close-on-click-modal='false' :close-on-press-escape='false'>
			<div class="clearfix">
				<div class="normal_input ">
					<div class="note_noteTop">
						<div id="noteToolbar">
							<button class="ql-bold"></button>
							<button class="ql-italic"></button>
							<button class="ql-image"></button>
							<select class="ql-align">
								<option value="justify" selected></option>
								<option value="center"></option>
								<option value="right"></option>
							</select>
						</div>
					</div>
					<div class="note_noteTite">
						<input v-model="title" type="text" placeholder="请输入标题" />
					</div>
					<div class="not_noteCont ">
						<quill-editor class="editor beautifulScroll" ref="noteQuillEditor" :content="content" @change="onEditorChange($event)" :options="editorOption"></quill-editor>
					</div>
					<div class="uploadBox" v-show="false">
						<div class="uploadList">
							<el-upload action="" :with-credentials='true' :on-success='uploadsuccess' :multiple='false' name='file' accept='image/*' :show-file-list='false' :http-request="formRequest">
								<div class="uploadbtninner">
									<i class="el-icon-plus"></i>
								</div>
							</el-upload>
							<div style="clear: both;"></div>
						</div>
					</div>
				</div>
				<div class="all_current">
					<el-button type="info" @click="cancelAdd">取 消</el-button>
					<el-button type="primary" @click="noteChaptersEdit" :disabled='dataloading'>确 定</el-button>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { listMajorByPid } from '@/api/major'
	import { mynoteList, notePublish, noteRemove, noteUpdate, getNoteTree, getNoteList } from '@/api/note.js'
	export default {
		data() {
			return {
				activeName: '1',
				commNavs: [{
					name: '课堂笔记',
					id: '1'
				}],
				defaultProps: {
					id: 'id',
					children: 'childrenList',
					label: 'name'
				},
				limit: 1000,
				typeList: [],
				//课堂笔记
				finiOnlistTree: [],
				finiOnnoteName: '',
				finiOnuserName: '',
				finiOntypeId: '',
				finiOnsectionId: '',
				finiOnname: '',
				finiOnlistData: [],
				finiOncurrent: 1,
				finiOntotal: 0,
				//编辑课堂笔记
				dataloading: false,
				note: false,
				firstnote: true,
				content: '',
				description: '',
				title: '',
				id: '',
				editorOption: {
					modules: {
						toolbar: '#noteToolbar',
					},
					placeholder: '请输入内容',
				},
			};
		},
		created() {
			this.getTypeList();
			this.getfiniOnListTree();
			this.getfiniOnListData();
		},
		methods: {
			handleNodeClick(data, node) {
				if(node.level == '1') {

				}
				if(node.level == '2') {

				}
				if(node.level == '3') {
					if(this.finiOnsectionId != data.id){
						this.finiOnsectionId = data.id;
					}else{
						this.finiOnsectionId = ''
					}
					this.getfiniOnListData();
				}
			},
			clearfiniOnFilter() {
				this.finiOnname = '';
				this.finiOntypeId = '';
				this.finiOnnoteName = '';
				this.finiOnuserName = '';
				this.finiOncurrent = 1
				this.getfiniOnListData();
			},
			finiOnCurrentChange(finiOncurrent) {
				this.finiOncurrent = finiOncurrent;
				this.getfiniOnListData();
			},
			getfiniOnListTree() {
				getNoteTree({}).then(res => {
					if(res.code == "OK") {
						this.finiOnlistTree = res.data;
					}
				})
			},
			getfiniOnListData() {
				var data = {
					title: this.finiOnnoteName ? this.finiOnnoteName : null,
					sectionId: this.finiOnsectionId ? this.finiOnsectionId : null,
					teacherName: this.finiOnuserName ? this.finiOnuserName : null,
					searchName: this.finiOnname ? this.finiOnname : null,
					courseType: this.finiOntypeId ? this.finiOntypeId : null,
				}
				getNoteList(data).then(res => {
					if(res.code == "OK") {
						this.finiOnlistData = res.data;
					}
				})
			},
			searchfiniOnData() {
				this.sectionId = '';
				this.getfiniOnListData();
			},
			getTypeList() {
				listMajorByPid({
					pid: this.majorIdForAll
				}).then(res => {
					this.typeList = res.data;
				})
			},
			cancelAdd() {
				this.note = false;
				this.content = '';
				this.description = '';
				this.title = '';
				this.id = '';
			},
			onEditorChange(res) {
				this.description = res.text;
				this.content = res.html;
			},
			openEdit(item) {
				this.note = true;
				if(this.firstnote) {
					this.firstnote = false
					this.editorUpload();
				}
				this.content = item.content;
				this.description = item.description;
				this.title = item.title;
				this.id = item.id;
			},
			editorUpload() {
				var that = this;
				this.$nextTick(() => {
					var noteQuillEditor = that.$refs.noteQuillEditor;
					var imgHandler = async function(image) {
						that.addImgRange = that.$refs.noteQuillEditor.quill.getSelection();
						if(image) {
							document.getElementsByClassName('uploadbtninner')[0].click()
						}
					}
					that.$refs.noteQuillEditor.quill.getModule("toolbar").addHandler("image", imgHandler);
				})
			},
			noteChaptersEdit() {
				this.dataloading = true;
				setTimeout(_ => {
					this.dataloading = false;
				}, 1000)
				if(!this.title) {
					this.$message.error('请输入标题！')
					return
				}
				if(!this.content) {
					this.$message.error('请输入内容！')
					return
				}
				var data = {
					id: this.id,
					title: this.title,
					content: this.content,
					description: this.description,
				}
				noteUpdate(data).then(res => {
					if(res.code == "OK") {
						this.cancelAdd()
						this.$message.success('修改成功')
						this.getfiniOnListData();
					} else {
						this.$message.error(res.msg)
					}
				})
			},
			deleteNote(item, index) {
				this.$confirm('确定删除笔记吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					var data = {
						noteId: item.id
					}
					noteRemove(data).then(res => {
						if(res.code == "OK") {
							this.getfiniOnListData()
						} else {
							this.$message.error('删除失败')
						}
					})
				}).catch(() => {
					this.$message.info('已取消删除')
				});
			},
			get_suffix(filename) {
				let pos = filename.lastIndexOf('.')
				let suffix = ''
				if(pos != -1) {
					suffix = filename.substring(pos)
				}
				return suffix
			},
			formRequest(file) {
				let that = this;
				var dir = 'vr/stuNote/';
				var noeDate = new Date();
				var year = noeDate.getFullYear();
				var month = noeDate.getMonth() + 1;
				month = month < 10 ? '0' + month : month;
				var day = noeDate.getDate();
				day = day < 10 ? '0' + day : day;
				dir = dir + year + "/" + month + "/" + day + '/';
				const uploadfile = file.file;
				const key = dir + noeDate.getTime() + this.get_suffix(file.file.name);
				putProgress(key, uploadfile, function(progressEvent) {
					let e = {}
					e.percent = progressEvent * 100 || 0;
					file.onProgress(e)
				}).then(res => {
					let e = {
						code: "OK",
						success: true,
						message: '',
						data: key
					}
					file.onSuccess(e)
				});
			},
			uploadsuccess(res, file, fileList) {
				var _this = this;
				var baseurl = this.baseurl;
				if(res) {
					var value = baseurl + res.data;
					_this.addImgRange = _this.$refs.noteQuillEditor.quill.getSelection()
					_this.$refs.noteQuillEditor.quill.insertEmbed(_this.addImgRange != null ? _this.addImgRange.index : 0, 'image', value, null)
				}
			},
		}
	}
</script>